<template>

    <div class="nav" v-if="showNavigation">

        <disconnect-bar></disconnect-bar>

        <div class="nav__mobile" v-show="!isDesktop && !isCardTuto">

            <button class="nav__mobile__item"
                    :class="{'nav__mobile__item-active': isNewslettersActive}"
                    @click="goNewsletters">
                <img class="img__24"
                     :src="`/img/navigation/newsletters-${ isNewslettersActive ? 'active' : 'unactive'}.svg`">
                <p class="mt__4" :class="{
                    'text-sRegular': !isNewslettersActive,
                    'text-sSemibold': isNewslettersActive
                }">{{ $t('menu_newsletters') }}</p>
            </button>

            <button class="nav__mobile__item"
                    :class="{'nav__mobile__item-active': isStatsActive}"
                    @click="goStats">
                <img class="img__24"
                     :src="`/img/navigation/stats-2-${ isStatsActive ? 'active' : 'unactive'}.svg`">
                <p class="mt__4" :class="{
                    'text-sRegular': !isStatsActive,
                    'text-sSemibold': isStatsActive
                    }">{{ $t('menu_statistics') }}</p>
            </button>

            <button class="nav__mobile__item"
                    :class="{'nav__mobile__item-active': isSettingsActive}"
                    @click="goSettings">
                <img class="img__24"
                     :src="`/img/navigation/settings-2-${ isSettingsActive ? 'active' : 'unactive'}.svg`">
                <p class="mt__4" :class="{
                    'text-sRegular': !isSettingsActive,
                    'text-sSemibold': isSettingsActive
                }">{{ $t('menu_settings') }}</p>
            </button>
        </div>

        <div class="nav__desktop" v-show="isDesktop">

            <div class="nav__desktop__head">
                <img src="/img/foxy/hero.svg" class="nav__desktop__logo">
            </div>

            <div class="nav__desktop__body">

                <button class="nav__desktop__item"
                        :class="{'nav__desktop__item-active': isNewslettersActive}"
                        @click="goNewsletters">
                    <img class="nav__desktop__item__ico"
                         :src="`/img/navigation/newsletters-${ isNewslettersActive ? 'active' : 'unactive'}.svg`">
                    <p :class="isNewslettersActive ? 'text-lSemibold' : 'text-lMedium'">{{ $t('menu_newsletters') }}</p>
                </button>

                <button class="nav__desktop__item mt__24"
                        :class="{'nav__desktop__item-active': isStatsActive}"
                        @click="goStats">
                    <img class="nav__desktop__item__ico"
                         :src="`/img/navigation/stats-2-${ isStatsActive ? 'active' : 'unactive'}.svg`">
                    <p :class="isStatsActive ? 'text-lSemibold' : 'text-lMedium'">{{ $t('menu_statistics') }}</p>
                </button>

                <button class="nav__desktop__item mt__24"
                        :class="{'nav__desktop__item-active': isSettingsActive}"
                        @click="goSettings">
                    <img class="nav__desktop__item__ico"
                         :src="`/img/navigation/settings-2-${ isSettingsActive ? 'active' : 'unactive'}.svg`">
                    <p :class="isSettingsActive ? 'text-lSemibold' : 'text-lMedium'">{{ $t('menu_settings') }}</p>
                </button>
            </div>

            <div class="nav__desktop__footer">

                <span class="nav__desktop__footer__line" @click="showMailboxes = !showMailboxes">
                    <p class="text-lSemibold color__moon mr__8">{{ $tc('mailbox_to_clean', mailboxesCount) }}</p>
                    <div class="nav__desktop__footer__bubble text-baseMedium color__white"
                         v-show="!showMailboxes">{{ mailboxesCount }}</div>
                    <img src="/img/newsletters-v2/chevron-down-grey.svg"
                         class="img__16"
                         :class="{'nav__desktop__footer__arrow-reverse': !showMailboxes}"
                    >
                </span>

                <div class="nav__desktop__footer__mailboxes mt__8" v-show="showMailboxes">

                    <div class="nav__desktop__footer__mailbox mt__16"
                         v-for="mailbox in mailboxes"
                         :class="{'shutdown': Mailboxes.isInvalidMailbox(mailbox), 'toggle-disabled': Mailboxes.isProviderShutdown(mailbox)}"
                         @click="toggleEmail(mailbox, !mailbox.isActive)">
                        <div class="nav__desktop__footer__mailbox__left" v-show="mailboxesCount > 1">
                            <img v-if="mailbox.invalidGrant" src="/img/icons/alert-red.svg" class="img__24">
                            <lottie-loader :size="24"
                                           v-else-if="isActiveMailboxesUpdating.indexOf(mailbox.email) > -1"></lottie-loader>
                            <img v-else :src="Mailboxes.mailboxStatusIcon(mailbox)" class="img__24">

                            <div class="at-least" v-if="atLeastErrorEmail === mailbox.email">
                                <p class="text-lRegular color__white">{{ $t('select_one_email') }}</p>
                                <button class="cta-small-dropdown mt__4" @click.stop="closeAtLeast">
                                    {{ $t('global_cta') }}
                                </button>
                                <img src="/img/icons/bubble-dark.svg">
                            </div>
                        </div>
                        <div class="nav__desktop__footer__mailbox__middle"
                             :class="{'shutdown': Mailboxes.isInvalidMailbox(mailbox)}">
                            <p class="email" :class="{'email-bold': mailbox.isActive, 'email-grey': !mailbox.isActive}">
                                {{ mailbox.email }}</p>
                            <p class="infos" :class="{'infos-reconnect': mailbox.invalidGrant}">
                                <span>{{ infosText(mailbox) }}</span>
                                <a class="text-sSemibold color__aquamarine"
                                   v-show="mailbox.invalidGrant">{{ $t('reconnect') }}</a>
                            </p>
                        </div>
                    </div>
                </div>

                <button class="add-mailbox"
                        @click="goAddInbox" v-show="showMailboxes">{{ $t('cleaning_done_add_mailbox_cta') }}
                </button>

            </div>

        </div>

        <toast ref="toast"></toast>

    </div>

</template>

<script>
import Vuex from 'vuex'

import Auth from '../modules/auth'
import Mailboxes from '../modules/mailboxes'
import Tag from '../modules/tag'

import DisconnectBar from '../components/DisconnectBar'
import LottieLoader from '../components/lottie/LottieLoader'
import Toast from '../components/Toast'

export default {

    name: 'cleanfox-navigation',

    components: {
        DisconnectBar,
        LottieLoader,
        Toast
    },

    watch: {
        showNavigation(bool) {
            this.updateIsNavigationOpen(bool)
        },

        '$route'() {
            this.updateShowNavigation()
        }
    },

    computed: {

        ...Vuex.mapGetters([
            'isCardTuto',
            'isConnected',
            'isActiveMailboxesUpdating',
            'laterList',
            'mailboxes',
            'newsletters'
        ]),

        Mailboxes() {
            return Mailboxes
        },

        isNewslettersActive() {
            return this.newslettersUrls.indexOf(this.$route.path) > -1
        },

        isStatsActive() {
            return this.statsUrls.indexOf(this.$route.path) > -1
        },

        isSettingsActive() {
            return /\/settings/.test(this.$route.path)
        },

        showNavigation() {
            return this.isPathWithNavigation
        },

        mailboxesCount() {
            return this.mailboxes.length
        },

        pathsWithNavigation() {
            return [...this.newslettersUrls, ...this.statsUrls, ...this.settingsUrls, ...this.othersUrls]
        }
    },

    data() {
        return {
            newslettersUrls: ['/newsletters', '/my-actions'],
            statsUrls: ['/stats', '/sponsorship'],
            settingsUrls: ['/settings'],
            othersUrls: ['/help'],
            isPathWithNavigation: false,
            showMailboxes: true,
            atLeastErrorEmail: ''
        }
    },

    mounted() {
        this.updateShowNavigation()
    },


    methods: {

        ...Vuex.mapActions([
            'updateIsActiveMailbox',
            'updateIsNavigationOpen'
        ]),

        goNewsletters() {

            Tag.clickAmplitude(this, 'newsletters')

            this.$router.push({path: '/newsletters'})
                .catch(() => {
                })

        },

        goStats() {

            Tag.clickAmplitude(this, 'stats')

            this.$router.push({path: '/stats'})
                .catch(() => {
                })

        },

        goSettings() {

            Tag.clickAmplitude(this, 'settings')

            this.$router.push({path: '/settings'})
                .catch(() => {
                })

        },

        goAddInbox() {
            Tag.clickGA(this, 'add_mailbox')
            this.$router.push({path: '/add-inbox'})
        },

        toggleEmail(mailbox, bool) {
            if (Mailboxes.isLastActiveEmail(mailbox)) {
                this.atLeastErrorEmail = mailbox.email
            } else if (Mailboxes.isInvalidMailbox(mailbox)) {
                Auth.reconnect(this, mailbox)
            } else if (Mailboxes.itCanBeDisabled(mailbox)) {
                Tag.clickGA(this, 'select_mailbox')
                this.updateIsActiveMailbox({email: mailbox.email, bool})
                    .catch(error => {
                        if (error && error.message === 'minimum_active_account') {
                            this.$refs.toast.open(this.$t('settings_error'))
                        } else {
                            this.$refs.toast.open()
                        }
                    })
            }
        },

        updateShowNavigation() {
            this.isPathWithNavigation = !!this.$route.matched.filter(match => this.pathsWithNavigation.some(path => match.regex.test(path))).length
        },

        closeAtLeast() {
            this.atLeastErrorEmail = ''
        },

        infosText(mailbox) {
            if (Mailboxes.isInvalidGrant(mailbox)) {
                return this.$t('account_disconected')
            } else if (Mailboxes.isProviderShutdown(mailbox)) {
                return this.$t('sorting_unavailable')
            } else {
                return this.$tc('cleaning_nb_mails_to_sort', this.totalNewslettersByEmail(mailbox.email), {'nb_emails': this.totalNewslettersByEmail(mailbox.email)})
            }
        },

        totalNewslettersByEmail(email) {
            return this.newsletters.filter(newsletter => newsletter.email === email).length + this.laterList.filter(newsletter => newsletter.email === email).length
        }
    }
}

</script>

<style lang="scss" scoped>

.nav {


    @media screen and (min-width: $above-tablet-length) {
        display: flex;
        border-right: 1px solid $divider;
        &:lang(ar-sa) {
            border-right: initial;
            border-left: 1px solid $divider;
        }
    }

    &__mobile {
        display: flex;
        flex-direction: row;
        align-items: center;

        &__item {
            display: flex;
            flex-direction: column;
            align-items: center;
            flex: 1;
            padding: 10px;
            background-color: $white;
            color: $stone;
        }

        &__item-active {
            color: $charcoal;
        }
    }

    &__desktop {
        overflow: auto;
        display: flex;
        flex-direction: column;
        width: 320px;

        &__head {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 24px;
        }

        &__body {
            display: flex;
            flex-direction: column;
            padding: 24px 8px;
            flex: 1;
        }

        &__footer {
            margin: 0 16px 16px;
            padding: 24px 16px;
            border: 2px solid var(--Primary-Alice-Blue, #E0F1FC);
            background: linear-gradient(155deg, #EEF9FF 0%, #E3F1FD 100%);
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            border-radius: 24px;

            &__line {
                display: flex;
                flex-direction: row;
                align-items: center;
                justify-content: flex-start;
                cursor: pointer;
            }

            &__bubble {
                padding: 2px 8px;
                border-radius: 100px;
                background-color: $aquamarine;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 8px;
            }

            &__arrow-reverse {
                transform: rotate(270deg);
            }

            &__mailboxes {
                width: 100%;
            }

            &__mailbox {
                display: flex;
                flex-direction: row;
                align-items: center;
                cursor: pointer;

                &__left {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding-right: 8px;
                    position: relative;

                    &:lang(ar-sa) {
                        padding-right: 0;
                        padding-left: 8px;
                    }

                    .at-least {
                        padding: 16px 20px;
                        width: 272px;
                        display: flex;
                        flex-direction: column;
                        align-items: flex-end;
                        text-align: start;
                        position: absolute;
                        bottom: 45px;
                        left: 0;
                        border-radius: 12px;
                        background: $midnight;

                        &:lang(ar-sa) {
                            left: inherit;
                            right: 0;
                        }

                        > img {
                            position: absolute;;
                            bottom: -10px;
                            left: 9px;

                            &:lang(ar-sa) {
                                left: inherit;
                                right: 9px;
                            }
                        }
                    }
                }

                &__middle {
                    text-align: start;
                    width: 100%;

                    .email {
                        font-size: 15px;
                        font-weight: 500;
                        line-height: 20px;
                    }

                    .email-bold {
                        font-weight: 600;
                    }

                    .email-grey {
                        color: $neutralsMoon;
                    }

                    .infos {
                        font-size: 12px;
                        font-weight: 500;
                        letter-spacing: normal;
                        color: $neutralsMoon;
                    }

                    .infos-reconnect {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;
                        font-size: 12px;
                        font-weight: 500;
                        line-height: 16px;

                        a {
                            text-decoration: underline;
                        }
                    }
                }
            }

            .add-mailbox {
                padding: 16px 40px;
                background-color: $aquamarine;
                border-radius: 32px;
                font-size: 17px;
                font-weight: 600;
                color: $white;
                width: 100%;
                margin-top: 32px;
            }
        }

        &__logo {
            height: 24px;
        }

        &__item {
            width: 100%;
            display: flex;
            flex-direction: row;
            padding: 16px;
            align-items: center;
            justify-content: flex-start;
            background-color: $white;
            cursor: pointer;
            color: $neutralsMoon;
            border-radius: 8px;

            &__ico {
                width: 24px;
                object-fit: contain;
                margin: 0 16px 0 0;

                &:lang(ar-sa) {
                    margin: 0 0 0 16px;
                }
            }
        }

        &__item-active {
            background-color: rgba(89, 177, 233, 0.08);
            color: $aquamarine;
        }
    }

}

.shutdown {

    .email {
        color: $stone;
    }

    .infos {
        color: $raspberry;
        font-size: 12px;
        font-weight: 500;
    }
}

.toggle-disabled {
    cursor: not-allowed;
}

.in-the-shadows {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5)
}

</style>
